module.exports = __webpack_public_path__ + "img/heading_no.9b36c141.svg";